import { type Association } from "@entities";
import { Stack } from "@mui/material";
import { useMemo, type FC } from "react";
import type { CustomCell } from "./types";

const Skills: FC<CustomCell<Association>> = ({ row }) => {
  const skillsName = useMemo(() => {
    return Array.from(
      new Set(row.original.user?.skills.map((userSkill) => userSkill.skill?.name)),
    );
  }, [JSON.stringify(row.original.user?.skills)]);

  return (
    <Stack flexDirection="row" alignItems="center">
      <span title={skillsName?.filter(Boolean).join(", ")}>
        {skillsName?.filter(Boolean).join(", ")}
      </span>
    </Stack>
  );
};

export default Skills;
